module.exports = __webpack_public_path__ + "img/tooltip.fc9ae929.svg";